const isTabletView = width =>
  width === 'md' || width === 'sm' || width === 'xs';

export default isTabletView;
